//
//
//
//
//
//
//
//
//
//
//
//
//

import $ from "jquery";
import ModalVideo from "./ModalVideo.vue";
export default {
    data() {
        return {
            isOpen: false,
        };
    },
    components: {
        ModalVideo,
    },
    props: {
        options: {
            type: Object,
            default() {
                return {
                    bg_color: "Primary",
                    text_color: "Light",
                    rounded: true,
                    icon: "arrow",
                    channel: "vimeo",
                    video: "",
                };
            },
            required: true,
        },
    },
    computed: {
        hasVideo() {
            return this.options.url.startsWith("#watch");
        },
        hasHash() {
            return !this.hasVideo && this.options.url.startsWith("#");
        },
        isExternal() {
            return !(this.options.url.startsWith("/") || this.options.url.includes(process.env.SITE_PATH || "https://burstsms.com"));
        },
        target() {
            if (this.options.new_tab) return "_blank";
            return "_self";
        },
        btnClass() {
            const classes = ["btn section-button"];

            if (this.options.bg_color === "Default") classes.push("btn-default");
            if (this.options.bg_color === "Primary") classes.push("btn-primary");
            if (this.options.bg_color === "Secondary") classes.push("btn-secondary");
            if (this.options.bg_color === "White") classes.push("btn-white");

            if (this.options.rounded) classes.push("btn--rounded");
            if (this.options.shadow) classes.push("btn--shadow");

            return classes.join(" ");
        },
    },
    methods: {
        onClick(event) {
            if (this.hasVideo) {
                event.preventDefault();
                this.isOpen = !this.isOpen;
                return;
            } else if (this.hasHash) {
                const hashBtn = $($(this.$refs.button).attr("href"));
                const offset = parseInt($(this.$refs.button).data("offset")) || -50;

                if (hashBtn.length > 0) {
                    event.preventDefault();
                    $("html, body").animate(
                        {
                            scrollTop: hashBtn.offset().top + offset,
                        },
                        200
                    );
                }

                return;
            }

            // if (this.options.new_tab) return window.open(this.options.url, "_blank");

            event.target.click();
        },
    },
};
